import { ENV } from '@hcs/webapps';

export const STRIPE_API_KEY =
  ENV === 'prod'
    ? 'pk_live_51HW2jSK9b0p3eKoSZA70TRYVOjMbK9LGF8F9WppromrZrHOxQ0lYZpyOgpoTp4lDOW6p8xgYxF2k6OCi2m1IicRm00S4P4Fb7s'
    : 'pk_test_51HKlL0BZwEeUsQayhejRp2iT3qP3tMlpzKxzBvkDnwYIQXtN5bFXAAUU7Lh9XDmyNG7SFiMyJHJXHOjmbCMMuiDA00HsanVzW4';
